import InternalOnboarding from "@/pages/internalOnboarding"
import { InternalOnboardingStepperContext } from "@/pages/internalOnboarding/InternalOnboardingStepperContext"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/auth/confirm_account/")({
  component: RouteComponent,
  validateSearch: (search) => {
    return {
      token: String(search.token),
    }
  },
})

function RouteComponent() {
  return (
    <InternalOnboardingStepperContext>
      <InternalOnboarding />
    </InternalOnboardingStepperContext>
  )
}
